<template>
    <div class="app">
        <router-view></router-view>
        <ModalMask :show="modal.show"></ModalMask>
        <Modal v-if="modal.show">
            <message v-if="modal.name === 'message'" :msg="modal.msg" v-on:close="close"></message>
        </Modal>
    </div>
</template>
<style rel="stylesheet/stylus" lang="stylus">
  ::-webkit-scrollbar
      width: 6px;
      height: 6px;
      /* background-color:#fff; */
      display: none;

  ::-webkit-scrollbar:hover
      background-color: #eee;

  ::-webkit-scrollbar-thumb
      min-height: 5px;
      min-width: 5px;
      -webkit-border-radius: 20px;
      border: 1px solid #AAA;
      background-color: #AAA;

  ::-webkit-scrollbar-thumb:hover
      min-height: 5px;
      min-width: 5px;
      -webkit-border-radius: 20px;
      border: 1px solid #444;
      background-color: #444;

  ::-webkit-scrollbar-thumb:active
      -webkit-border-radius: 20px;
      border: 1px solid #444;
      background-color: #444;
</style>
<script>
    import '@babel/polyfill';
    import {mapState} from 'vuex';
    import Mask from './components/Mask/mask.vue';
    import Modal from './components/Modal/modal.vue';
    import message from './components/message.vue';
    import store from './store/index';
    import * as types from './store/mutation-type';
    import { isMobile } from './tools/utils';
    import 'animate.css/animate.min.css';

    export default{
        computed: {
            ...mapState({
                modal: state => state.modal
            })
        },
        data() {
            return {
                isMobile: isMobile()
            }
        },
        mounted() {
        },
        components: {
            ModalMask: Mask,
            Modal,
            message
        },
        methods: {
            close() {
                let _this = this;
                store.commit(types.HIDE_MODAL);
                if(_this.modal.redirecturl) {
                    console.log(_this.modal.redirecturl)
                    location.href = _this.modal.redirecturl;
                }
            }
        }
    }
</script>
